import { createBrowserRouter, Navigate } from "react-router";
import { RootErrorBoundary } from "@/routes/root-error-boundary";
import Root from "@/routes/root";
import * as Sentry from "@sentry/react";
import BaseDataRoute from "@/routes/base-data/base-data";
import { baseDataRoutes } from "@/routes/base-data/base-data-routes";
import ProcessRoute from "./processes/[processId]/process/process";
import { processRoutes } from "./processes/[processId]/process/process-routes";
import { ProcessesRoute } from "./processes/processes-route";
import { DeliveriesRoute } from "./deliveries/deliveries-route";
import { StatsRoute } from "./stats/stats-route";

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "",
        element: <Navigate to="processes" replace />,
      },
      {
        path: "base-data",
        element: <BaseDataRoute />,
        children: baseDataRoutes,
      },
      {
        path: "processes",
        element: <ProcessesRoute />,
      },
      {
        path: "deliveries",
        element: <DeliveriesRoute />,
      },
      {
        path: "stats",
        element: <StatsRoute />,
      },
      {
        path: "processes/:processId",
        element: <ProcessRoute />,
        children: processRoutes,
      },
    ],
    errorElement: <RootErrorBoundary />,
  },
]);

export default router;
